<script lang="ts">
	import { page } from '$app/state';
	import { UpdateRegisteredCarStore } from '$houdini';
	import Button from '$lib/components/atoms/button/Button.svelte';
	import Icon from '$lib/components/icons/Icon.svelte';
	import { carEnergies } from '$lib/i18n/computed/carEnergies';
	import * as m from '$paraglide/messages';
	import RegisterOrEditCarModal from './RegisterOrEditCarModal.svelte';

	interface Props {
		onUpdateCar?: () => void;
	}

	const { userProfileStore } = page.data;
	const { onUpdateCar }: Props = $props();
	const car = $derived($userProfileStore?.data?.me.car ?? undefined);

	const sharedContainerStyles = 'border-neutral-soft p-4 rd-2 w-full md:w-75 flex flex-col';

	let updateRegisteredCarStore: UpdateRegisteredCarStore;
	let isModalOpen = $state(false);

	function deleteUserCar() {
		if (!updateRegisteredCarStore) {
			updateRegisteredCarStore = new UpdateRegisteredCarStore();
		}

		updateRegisteredCarStore.mutate({ input: { carId: null } }).then(() => onUpdateCar?.());
	}
</script>

<div class="flex flex-col gap-1">
	<div class="text-sm">{m.profile__tabs__settings__vehicle()}</div>
	{#if car}
		<div class={[sharedContainerStyles, 'border-0.5 border-solid shadow-smooth-bottom-1 gap-4']}>
			<div class="flex flex-col gap-2">
				<div class="text-md">
					<div class="text-bold">{car.fullname}</div>
					<div>{carEnergies(car.energy)} • {car.constructionYears}</div>
				</div>
				{#if car.motor}
					<div class="text-sm">{car.motor}</div>
				{/if}
			</div>
			<div class="flex gap-1">
				<Button
					text={m.action__edit()}
					icon="edit"
					color="light"
					class="flex-1"
					onclick={() => (isModalOpen = true)}
				/>
				<Button
					text={m.action__delete()}
					icon="delete"
					variant="outline"
					color="light"
					class="flex-1"
					onclick={deleteUserCar}
				/>
			</div>
		</div>
	{:else}
		<button
			class={[sharedContainerStyles, 'border-1 border-dashed items-center justify-center h-39 text-coloredneutral-weak bg-transparent cursor-pointer']}
			onclick={() => (isModalOpen = true)}
		>
			<Icon icon="add" tag="span" />
			<span>{m.action__add()}</span>
		</button>
	{/if}
	{#if isModalOpen}
		<RegisterOrEditCarModal bind:open={isModalOpen} onSaveCar={onUpdateCar} />
	{/if}
</div>
